import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { motion } from 'framer-motion';
import { fadeIn } from '../../../shared/helpers/animation';
import FormInputFloat from '../../../shared/components/FormInputFloat';
import { emailValidator } from '../../../shared/helpers/form-validators';
import AnimatedLogoText from '../../../shared/components/AnimatedLogoText';
import Button from '../../../shared/components/Button';
import { useNavigate } from 'react-router-dom';
import PageTransitionWrapper from '../../../shared/components/PageTransitionWrapper';
import useProfileService from '../../../shared/services/useProfileService';
import { useAppSelector } from '../../../shared/store/store';
import { LoadingState } from '../../../shared/types';
import { Buffer } from 'buffer';

const Register: React.FC = () => {
  const [ showEmail, setShowEmail ] = useState(false);


  // Obfuscated and delayed email link to prevent crawler scraping.
  // Inspired from https://github.com/darthdeus/react-obfuscated-mailto
  // But wait, this is too good and messes up browser handling of mailto:
  // links, e.g. if you set up the browser to use gmail as a protocol handler.
  const EmailText = () => {
    /*const email = Buffer.from("aW5mb0BzY2FmZm9sZC5oZWFsdGg=", "base64");
    return showEmail ?
              (<a 
                href={"mailo:"+email} 
                className="text-primary-light font-bold underline">
                {email.toString('ascii')}
              </a>) : (<div/>);
    */
   return (<a href="mailto:info@scaffold.health?subject=Caloosha%20Account%20Request&body=Name:%0D%0AOrganization:" 
              className="text-primary-light font-bold underline">
                info@scaffold.health</a>);
           
  }
  useEffect(() => {
    setTimeout(()=>setShowEmail(true), 1500);
  }, []);

  return (
    <PageTransitionWrapper>
      <main className="flex h-screen w-full items-center justify-center bg-gradient-to-bl from-cyan-400 to-cyan-900">
        <motion.div className=" flex w-3/4 flex-col items-center p-6 md:w-2/4 lg:w-2/6">
          <div className="w-2/4">
            <AnimatedLogoText color="white" />
          </div>
          <motion.div
            className="mt-8 sm:mx-auto sm:w-full sm:max-w-md"
            variants={fadeIn}
            initial="hidden"
            animate="visible"
          >
            <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
              <h2 className="mb-8 text-2xl font-bold text-primary-light">No profile found</h2>
              To set up your caregiver account in Caloosha, please request access at <br/>
              <EmailText/>.
            </div>
          </motion.div>
        </motion.div>
      </main>
    </PageTransitionWrapper>
  );
};

export default Register;
